import { makeAutoObservable } from 'mobx'

import WebviewService, { VersionCode_WebCameraQr } from '@/service/webview.service'
import appPostMsg from '@/utils/appPostMsg'

import { getQrEntryMode } from './_utils/qrEntryMode'
import { openQrPcNotice } from './QrPcNotice/openQrPcNotice'

export const getEntryMode = () =>
  getQrEntryMode({
    isAppAndroid: WebviewService.isAppAndroid,
    isAppIpad: WebviewService.isAppIpad,
    appVersion: WebviewService.version,
    webCameraAppVersion: VersionCode_WebCameraQr,
    hasNativeScanner: typeof window.AndroidInterface?.scanQRCode === 'function',
    // react-device-detect 의 isMobile 은 iPadOS 데스크톱 UA 를 놓쳐 isIpad(isIPad13) 를 함께 본다
    isTabletOrPhone: WebviewService.isMobile || WebviewService.isIpad,
  })

/** GNB 버튼과 채점 시트의 [다음 QR 스캔] 이 같은 카메라 레이어를 연다 */
class QrScanStore {
  isCameraOpen = false

  constructor() {
    makeAutoObservable(this)
  }

  start = () => {
    switch (getEntryMode()) {
      case 'camera':
        this.isCameraOpen = true
        return
      case 'native-scanner':
        appPostMsg.scanQR()
        return
      case 'pc-notice':
        openQrPcNotice()
        return
      case 'hidden':
        return
    }
  }

  /** GNB 버튼 노출 — PC 도 안내를 보여 주려고 버튼은 둔다 */
  get canStart() {
    return getEntryMode() !== 'hidden'
  }

  /** 실제로 찍을 수 있는 기기인가. PC 는 안내만 떠서 연속 채점 버튼을 두지 않는다 */
  get canScan() {
    const mode = getEntryMode()
    return mode === 'camera' || mode === 'native-scanner'
  }

  closeCamera = () => {
    this.isCameraOpen = false
  }
}

export const qrScanStore = new QrScanStore()
